<template>
  <el-emp-footer
    :helpData="helpData"
    :copyRightb="copyRightb"
    :copyRighta="copyRighta"
    :qrCode="qrCode"
    :isShowCopyright="isShowCopyright"
  />
</template>

<script>
export default {
  data() {
    return {
      copyRighta: "Copyright©2022中交电商All rights reserved. ",
      copyRightb: "闽ICP备2022005227号-2 中交电商",
      qrCode: require("@/basa/assets/images/code.jpg"),
      isShowCopyright: true,
      helpData: [
        {
          tit: this.$t("page.content.aboutUs"),
          list: [
            { label: this.$t("page.content.introPlatform"), url: "" },
            { label: this.$t("page.content.contactUs"), url: "" },
            {
              label: this.$t("page.content.relevantPoliciesAndRegulations"),
              url: ""
            }
          ]
        },
        {
          tit: this.$t("page.content.purchaser"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "" },
            { label: this.$t("page.content.videoTutorial"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.supplier"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "" },
            { label: this.$t("page.content.videoTutorial"), url: "" },
            { label: this.$t("page.content.netInformation"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.commonProblem"),
          list: [
            { label: this.$t("page.content.purchaseCommonProblem"), url: "" },
            { label: this.$t("page.content.supplierCommonProblem"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.serviceCenter"),
          list: [
            { label: this.$t("page.content.onlineCounsel"), url: "1" },
            { label: this.$t("page.content.afterSalesService"), url: "2" },
            { label: this.$t("page.content.feedback"), url: "3" },
            { label: this.$t("page.content.fileTemplateDownload"), url: "4" }
          ]
        },
        {
          tit: this.$t("page.content.supplyChainFinanceCenter"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "5" },
            { label: this.$t("page.content.commonProblem"), url: "6" }
          ]
        }
      ]
    };
  },
  mounted() {},
  methods: {
    search(kw) {
      console.log(kw);
    }
  }
};
</script>

<style scoped lang="scss"></style>
